import CardInfo from './CardInfo'

const Rules = () => {
  return (
    <>
      <CardInfo
        text={
          <>
            — Esta é uma base fechada.
            <br />
            <br />
            — São permitidas três frags por pessoa, apenas duas podendo ser
            personagens canon, primeiramente para não ocupar vagas e
            segundamente para que nenhum deles seja menosprezado.
            <br />
            <br />
            — Fazer o máximo para não misturar o on com off, não queremos que a
            convivência entre os membros da base se torne ruim, é para ser um
            ambiente seguro e de descontração.
            <br />
            <br />
            — Aceitamos ocs mas no caso de um personagem com parentesco com
            outro já existente, pedir permissão da base primeiro.
            <br />
            <br />
            — No caso de um plot que vá interferir na história de outros
            personagens ou no plot da base, buscar aprovação antes.
            <br />
            <br />
            — Proibido plots e eventos/turnos que envolvam situações e ações de
            cunho mais pesado, incluindo no passado do personagem (ex:
            canibalismo, pedofilia, zoofilia, abusos (sexuais) e etc) Outros
            como abusos físicos/verbais, aborto, t.a podem estar no plot mas não
            podem ter narrações gráficas sobre estes e mesmo que sejam citados
            de forma leve é obrigatório colocar t.w. Além de terem menores de
            idade no RPG é uma questão de ética.
            <br />
            <br />
            — Deve se ter no mínimo 15 anos para entrar na base!
            <br />
            <br />
            — Podemos manter uma reserva por apenas 24 horas no máximo!
            <br />
            <br />
            — Inatividade de uma semana SEM AVISO resultará em ban! A
            inatividade sendo vista de acordo com o grupo on. Damos três dias de
            aviso antes de retirar de fato.
            <br />
            <br />
            — Panelinhas são ESTRITAMENTE proibidas, pedimos que todos interajam
            com todos, esse é o mínimo para que o RPG seja harmonioso.
            <br />
            <br />
            — Não será tolerado qualquer tipo de intolerância em OFF, no caso de
            problemas tanto com a base quanto com qualquer membro desta, contate
            um dos ADMS, para que possam ser resolvidos o mais rápido possível.
            <br />
            <br />
            <strong>
              — Ficaremos atentos e o descumprimento de qualquer uma dessas
              regras irá gerar aviso inicialmente, se pravalecer, resultará em
              ban.
            </strong>
            <br />
            <br />
            Acima de tudo, se divirta!
          </>
        }
      />
    </>
  )
}

export default Rules
